import { render, staticRenderFns } from "./pgcImport.vue?vue&type=template&id=3885dd36&scoped=true"
import script from "./pgcImport.vue?vue&type=script&lang=js"
export * from "./pgcImport.vue?vue&type=script&lang=js"
import style0 from "./pgcImport.vue?vue&type=style&index=0&id=3885dd36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3885dd36",
  null
  
)

export default component.exports